import {
    AlertFilled,
    AlertOffFilled,
    AlertOffRegular,
    AlertRegular,
    bundleIcon,
} from '@fluentui/react-icons';
import { Win32Icon20px } from 'owa-command-ribbon-win32-icon';
import areNotificationsDisabled from 'owa-notifications-settings/lib/selectors/areNotificationsDisabled';
import isWin32StylingEnabled from 'owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled';

const NotificationsIcon = bundleIcon(AlertFilled, AlertRegular);
const NotificationsOffIcon = bundleIcon(AlertOffFilled, AlertOffRegular);

export default function renderNotificationsIcon(): React.JSX.Element {
    if (isWin32StylingEnabled()) {
        return <Win32Icon20px registryKey="NotificationsWin32" outlineOnly={true} />;
    }

    // Show unmuted alert icon if notifications are enabled or are loading
    return areNotificationsDisabled() ? <NotificationsOffIcon /> : <NotificationsIcon />;
}
